module.exports = __webpack_public_path__ + "static/img/16.2cb1d0f0.png";